import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";

const ExportCompanyDocsExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Company Documents");

  const t = i18n.t.bind(i18n);

  worksheet.columns = [
    { header: t("documentsTable.th.id"), key: "id", width: 12 },
    { header: t("documentsTable.th.category"), key: "category", width: 20 },
    { header: t("documentsTable.th.subject"), key: "subject", width: 30 },
    { header: t("documentsTable.th.documentName"), key: "documentName", width: 30 },
    { header: t("documentsTable.th.fileType"), key: "fileType", width: 15 },
    { header: t("documentsTable.th.dateTime"), key: "createdAt", width: 25 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Company_Documents_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportCompanyDocsExcel;
